export default "__VITE_ASSET__Bn$LxEQm__"